$(function() {
    $("#slider-range-can_nang").slider({
        range: "min",
        min: 0,
        max: 200,
        value: 0,
        slide: function(event, ui) {
            $("#slider-range-can_nang-amount").html(ui.value);
            $("input[name='can_nang']").val(ui.value > 0 ? ui.value : '');
        }
    });
    $("#slider-range-can_nang-amount").html($("#slider-range-can_nang").slider("value"));
    $("input[name='can_nang']").val($("#slider-range-can_nang").slider("value"));

    $("#slider-range-chieu_cao").slider({
        range: "min",
        min: 0,
        max: 250,
        value: 0,
        slide: function(event, ui) {
            $("#slider-range-chieu_cao-amount").html(ui.value);
            $("input[name='chieu_cao']").val(ui.value > 0 ? ui.value : '');
        }
    });
    $("#slider-range-chieu_cao-amount").html($("#slider-range-chieu_cao").slider("value"));
    $("input[name='chieu_cao']").val($("#slider-range-chieu_cao").slider("value"));

    $("#slider-range-do_tuoi").slider({
        range: "min",
        min: 0,
        max: 100,
        value: 0,
        slide: function(event, ui) {
            $("#slider-range-do_tuoi-amount").html(ui.value);
            $("input[name='do_tuoi']").val(ui.value > 0 ? ui.value : '');
        }
    });
    $("#slider-range-do_tuoi-amount").html($("#slider-range-do_tuoi").slider("value"));
    $("input[name='do_tuoi']").val($("#slider-range-do_tuoi").slider("value"));

    $('form.bmi-form').each(function(i, obj) {
        let $form = $(obj);
        let rules = {
            gioi_tinh: {
                required: true
            },
            chieu_cao: {
                required: true,
                min: 1
            },
            can_nang: {
                required: true,
                min: 1
            },
            do_tuoi: {
                required: true,
                min: 1
            },
        };

        let messages = {
            gioi_tinh: {
                required: "Vui lòng chọn giới tính.",
            },
            chieu_cao: {
                required: "Vui lòng chọn chiều cao.",
                min: "Vui lòng chọn chiều cao."
            },
            can_nang: {
                required: "Vui lòng chọn cân nặng.",
                min: "Vui lòng chọn cân nặng."
            },
            do_tuoi: {
                required: "Vui lòng chọn độ tuổi.",
                min: "Vui lòng chọn độ tuổi."
            },
        };

        $form.validate({
            ignore: '',
            rules: rules,
            messages: messages,
            errorPlacement: function (error, element) {
                if ($(element).data('custom-error')) {
                    let errorContainerId = `error-${element.attr("id")}`;
                    $(`#${errorContainerId}`, $form).html(error);
                } else {
                    error.insertAfter(element);
                }
            },
            success: function (label, element) {
                if ($(element).data('custom-error')) {
                    let errorContainerId = `error-${element.id}`;
                    $(`#${errorContainerId}`, $form).html('');
                }
            },
        });
    });

});

function ClearError(form){
    $(form).find('.error').each(function () {
        console.log($(this));
        if($(this).is("input")){
            $(this).removeClass('error');
        }
        else if ($(this).is("div") || $(this).is("label")) {
            $(this).remove();
        }
    })
}

function ClearData(form){
    ClearError(form);
    $('#view-bmi').html(null);
    $('#view-bmi-content').html(null);

    $("#slider-range-chieu_cao").slider("value", 0);
    $("#slider-range-chieu_cao-amount").html(0);
    $('input[name=chieu_cao]').val(0);

    $("#slider-range-can_nang").slider("value", 0);
    $("#slider-range-can_nang-amount").html(0);
    $('input[name=can_nang]').val(0);

    $("#slider-range-do_tuoi").slider("value", 0);
    $("#slider-range-do_tuoi-amount").html(0);
    $('input[name=do_tuoi]').val(0);

    $('input[name=gioi_tinh]').prop('checked', false);
}

$(document).on('click', '#btn-reset', function (e) {
    let form = $(this).closest('.bmi-form');
    $('#panel-bmi-view-result').addClass('d-none');
    $('#panel-bmi-view').removeClass('d-none');
    ClearData(form);
})

let objFunc = {
    removeError: function () {
        $('div.alert-wrapper').html('');
        $('.error-message').html('');
        $('input, select').removeClass('error');
    },
    showError: function (xhr) {
        this.removeError();

        let responseJSON = xhr.responseJSON ? xhr.responseJSON : JSON.parse(xhr.responseText);

        if ('errors' in responseJSON) {
            $.each(responseJSON.errors, function (field, messages) {
                let errorMessage = messages[0];
                let inputElement = $('#' + field);
                let errorElement = $('#error-' + field);

                if (errorElement.length) {
                    let errorLabel = `<label id="${field}-error" class="error" for="${field}">${errorMessage}</label>`;
                    errorElement.html(errorLabel);
                }
                if (inputElement.length) {
                    inputElement.addClass('error');
                }
            });
        } else {
            let alertBox = `<div class="alert alert-danger" role="alert">${responseJSON.message}</div>`;
            $('div.alert-wrapper').html(alertBox);
        }
    }
};


$(document).on('click', '#btn-view-result', function (e) {
    let eleButton = $(this);
    window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);
    let form = $(this).closest('.bmi-form');
    let valid = typeof $.fn.validate == 'undefined' ? form[0].reportValidity() : form.valid();
    if (!valid) {
        let firstInput = form.find('input.error').first();
        if (firstInput.length > 0) {
            $('html').animate({
                scrollTop: firstInput.offset().top - 100
            }, 200);
        }

        window.hideLoading(eleButton[0], '', false);
        return false;
    }

    window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);

    let formData = form.serializeArray();
    $.ajax({
        method: "POST",
        url: form.attr('action'),
        data: formData,
    }).then(function (response) {

        if(response.code == 200){
            $('#panel-bmi-view').addClass('d-none');
            $('#panel-bmi-view-result').removeClass('d-none');
            
            let bmi = response.data.bmi;
            $('#view-bmi').html(response.data.bmi);
            $('#view-bmi-content').html(response.data.context);
            if (bmi < 18.5){
                $(".results").css("background-color", "#3FC6FB");
            } else if (bmi >= 18.5 && bmi < 25){
                $(".results").css("background-color", "#0CC656");
            } else if (bmi >= 25 && bmi < 30) {
                $(".results").css("background-color", "#FFD63A");
            } else if (bmi >= 30 && bmi < 35) {
                $(".results").css("background-color", "#FF9940");
            } else if (bmi >= 35) {
                $(".results").css("background-color", "#FD2C2C");
            }
        }

        objFunc.removeError();
        window.hideLoading(eleButton[0], '', false);
    }).fail( function(xhr, textStatus, errorThrown) {
        objFunc.showError(xhr);
        window.hideLoading(eleButton[0], '', false);
        return false;
    });
})